import { ColumnBase } from "./ColumnBase";
import { ITableColumn } from "./ITableColumn";
import { TableColumnTypes } from "./TableColumnTypes";
import { ColumnAmpel } from "./ColumnAmpel";
import { MsoTable } from "./MsoTable";
import { ColumnDate } from "./ColumnDate";
import { ColumnDouble } from "./ColumnDouble";
import { ColumnBool } from "./ColumnBool";
import { ColumnString } from "./ColumnString";
import { ColumnExpand } from "./ColumnExpand";
import { ColumnCustom } from "./ColumnCustom";
import { ColumnEditIcon } from "./ColumnEditIcon";
import { ColumnDocuments } from "./ColumnDocuments";
import { AttributesReader } from "../../Frame/AttributesReader";
import { ColumnDrag } from "./ColumnDrag";
import { ColumnCheckbox } from "./ColumnCheckbox";
import { ColumnDeleteIcon } from "./ColumnDeleteIcon";
import { ColumnDropdown } from "./ColumnDropdown";
import { ColumnProgress } from "./ColumnProgress";
import { ColumnUser } from "./ColumnUser";
import { ColumnSearchIcon } from "./ColumnSearchIcon";
import { ColumnButton } from "./ColumnButton";
import { ColumnHarvey } from "./ColumnHarvey";
import { ColumnCopyIcon } from "./ColumnCopyIcon";
import { ColumnStatusFinished } from "./ColumnStatusFinished";
import { ColumnPicture } from "./ColumnPicture";
import { ColumnExportIcon } from "./ColumnExportIcon";
import { ColumnYesNoRadioButtons } from "./ColumnYesNoRadioButtons";

export class Columns {
    public items: Array<ColumnBase> = [];

    public get totalWidth(): number {
        let width: number = 0;
        for (let col of this.items) {
            width += col.width;
        }
        return width;
    }

    public create(table: MsoTable, rootId: string, columns: ITableColumn[]) {
        let index = 0;

        if (table.props.onBeforeCreateColumns) {
            table.props.onBeforeCreateColumns(columns);
        }

        for (let def of columns) {
            let col: ColumnBase;
            col = this.getColumnByType(table, def, rootId);
            col.index = index++;
            this.items.push(col);
        }

        if (table.props.flexCompleteWidth) {
        }
    }

    public getColumnByType = (table: MsoTable, def: ITableColumn, rootId: string): ColumnBase => {
        let col;

        switch (def.type) {
            case TableColumnTypes.Ampel:
                col = new ColumnAmpel(table, def, rootId);
                break;
            case TableColumnTypes.Date:
                col = new ColumnDate(table, def, rootId);
                break;
            case TableColumnTypes.Double:
                col = new ColumnDouble(table, def, rootId);
                break;
            case TableColumnTypes.HasDocument:
            case TableColumnTypes.HasPicture:
            case TableColumnTypes.Bool:
                col = new ColumnBool(table, def, rootId);
                break;
            case TableColumnTypes.Int:
                col = new ColumnDouble(table, def, rootId);
                break;
            case TableColumnTypes.String:
                col = new ColumnString(table, def, rootId);
                break;
            case TableColumnTypes.User:
                col = new ColumnUser(table, def, rootId);
                break;
            case TableColumnTypes.Expand:
                col = new ColumnExpand(table, def, rootId);
                break;
            case TableColumnTypes.Custom:
                col = new ColumnCustom(table, def, rootId);
                break;
            case TableColumnTypes.EditIcon:
                col = new ColumnEditIcon(table, def, rootId);
                break;
            case TableColumnTypes.Documents:
                col = new ColumnDocuments(table, def, rootId);
                break;
            case TableColumnTypes.Drag:
                col = new ColumnDrag(table, def, rootId);
                break;
            case TableColumnTypes.Checkbox:
                col = new ColumnCheckbox(table, def, rootId);
                break;
            case TableColumnTypes.YesNoRadioButtons:
                col = new ColumnYesNoRadioButtons(table, def, rootId);
                break;
            case TableColumnTypes.DeleteIcon:
                col = new ColumnDeleteIcon(table, def, rootId);
                break;
            case TableColumnTypes.Dropdown:
                col = new ColumnDropdown(table, def, rootId);
                break;
            case TableColumnTypes.Progress:
                col = new ColumnProgress(table, def, rootId);
                break;
            case TableColumnTypes.SearchIcon:
                col = new ColumnSearchIcon(table, def, rootId);
                break;
            case TableColumnTypes.Button:
                col = new ColumnButton(table, def, rootId);
                break;
            case TableColumnTypes.Harvey:
                col = new ColumnHarvey(table, def, rootId);
                break;
            case TableColumnTypes.CopyIcon:
                col = new ColumnCopyIcon(table, def, rootId);
                break;
            case TableColumnTypes.StatusFinished:
                col = new ColumnStatusFinished(table, def, rootId);
                break;
            case TableColumnTypes.Picture:
                col = new ColumnPicture(table, def, rootId);
                break;
            case TableColumnTypes.ExportIcon:
                col = new ColumnExportIcon(table, def, rootId);
                break;
            default:
                throw "MsoTable: undefined column type: " + def.type;
        }

        return col;
    }

    autoSize(totalWidth: number) {
        totalWidth -= 22;
        if (this.items.length > 0 && totalWidth > 0) {
            let singleWidth = Math.round(totalWidth / this.items.length);
            for (let i = 0; i < this.items.length - 1; i++) {
                this.items[i].width = singleWidth;
                totalWidth -= singleWidth;
            }
            this.items[this.items.length - 1].width = totalWidth - 4;
        }
    }

    public createFromHtml(table: MsoTable, rootId: string, columnElement: HTMLElement): void {
        let items: ITableColumn[] = [];
        let cols = columnElement.querySelectorAll<HTMLElement>("column");
        cols.forEach((element: HTMLElement) => {
            const attr = new AttributesReader(element);
            items.push({
                type: attr.getNumber("type"),
                headerText: attr.getString("header-text"),
                dataField: attr.getString("field"),
                align: attr.getNumber("align"),
                sortAsc: attr.getBool("sort-asc"),
                number: attr.getNumber("number"),
                cssClass: attr.getString("css-class"),
                decimals: attr.getNumber("decimals"),
                headerCssClass: attr.getString("header-css-class"),
                htmlEncode: attr.getBool("html-encode"),
                isSortable: attr.getBool("is-sortable"),
                toolTip: attr.getString("tool-tip"),
                useTime: attr.getBool("use-time"),
                fireOnCellClick: attr.getBool("fire-on-cell-click"),
                fixedWidth: attr.getString("fixed-width"),
                isEditable: attr.getBool("is-editable"),
                isEditLink: attr.getBool("is-edit-link"),
                sourceField: attr.getString("source-field"),
                sourceName: attr.getString("source-name"),
                editType: attr.getNumber("edit-type"),
                visibilityField: attr.getString("visibility-field"),
                width: attr.getNumber("width", 100)
            });

        });
        this.create(table, rootId, items);
    }

    public findByField(field: string): ColumnBase {
        for (let col of this.items) {
            if (col.field == field) {
                return col;
            }
        }
        return null;
    }

    public findByType(type: TableColumnTypes): ColumnBase {
        for (let col of this.items) {
            if (col.type == type) {
                return col;
            }
        }
        return null;
    }
}